<template>
  <div id="action-panel">
    <div class="message" :class="{ 'underline': hasActionText }">{{message}}</div>
    <button v-if="hasActionText" type="button" class="action" @click="$emit('action-click')">{{actionText}}</button>
  </div>
</template>

<script>
export default {
  name: 'ActionPanel',
  props: {
    message: {
      type: String,
      default: ''
    },
    actionText: {
      type: String,
      default: null
    },
  },
  computed: {
    hasActionText() {
      return this.actionText && this.actionText.length;
    }
  },
  methods: {
  }
}
</script>

<style scoped>
#action-panel {
  margin: auto;
  margin-top: 1em;
  display: block;
  max-width: calc(100% - 5rem);
  max-height: calc(100% - 5rem);
  border: none;
  border-radius: 15px;
  color: #fff;
  padding: 15px 40px;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.8);
}
#action-panel > .message {
  display: block;
  width: 100%;
  text-align: center;
  border-radius: 0;
  font-size: 1.5em;
  font-weight: bold;
  background: white;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
#action-panel > .message.underline {
  border-bottom: 1px solid #333;
  padding-bottom: 4px;
  margin-bottom: 1rem;
}
#action-panel > .action {
  background-color: rgba(20, 20, 20, 0.8);
  border: none;
  height: auto;
  padding: 10px 40px;
  border-radius: 20px;
  width: fit-content;
  text-align: center;
  display: block;
  margin: auto;
  cursor: pointer;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  outline: none;
  color: inherit;
}

@media only screen and (min-width: 800px) {
  #action-panel {
    margin: auto;
    margin-top: 4em;
  }
}
</style>